"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newComposedPlaceholder = exports.newPlaceholder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var uuid_1 = require("uuid");
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var hooks_1 = require("./hooks");
/**
 * Create a new placeholder.
 * See {@link IPlaceholder}.
 *
 * @public
 */
function newPlaceholder(defaultValue, options) {
    if (options === void 0) { options = {}; }
    var id = options.id, validate = options.validate;
    var placeholder = {
        type: "IPlaceholder",
        id: id !== null && id !== void 0 ? id : uuid_1.v4(),
        defaultValue: defaultValue,
        validate: validate,
        // eslint-disable-next-line react-hooks/rules-of-hooks
        use: function () { return hooks_1.usePlaceholder(placeholder); },
    };
    return placeholder;
}
exports.newPlaceholder = newPlaceholder;
/**
 * Create a new composed placeholder.
 * See {@link IComposedPlaceholder}.
 *
 * @public
 */
function newComposedPlaceholder(placeholders, computeValue) {
    if (computeValue === void 0) { computeValue = identity_1.default; }
    var placeholder = {
        type: "IComposedPlaceholder",
        placeholders: placeholders,
        computeValue: computeValue,
        // eslint-disable-next-line react-hooks/rules-of-hooks
        use: function (resolutionContext) { return hooks_1.useComposedPlaceholder(placeholder, resolutionContext); },
    };
    return placeholder;
}
exports.newComposedPlaceholder = newComposedPlaceholder;
//# sourceMappingURL=factory.js.map